import {useNavigate, useParams} from "react-router-dom";
import FormButton from "../../components/form-button";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import {useEffect, useState} from "react";
import associateServices from "../../services";
import Loading from "../../components/loading";
import stringHelper from "../../helpers/string-helper";

const EmailVerified = () => {
    const {t, i18n} = useTranslation()
    const currentLanguage = i18n.language; // Get the current language

    const {activeLanguage} = useSelector(state => state.globalReducer)

    const navigate = useNavigate()
    let {token} = useParams()

    const [loading, setLoading] = useState(true)
    const [confs, setConfs] = useState({})


    useEffect(() => {
        associateServices.checkEmail({
            token, language: activeLanguage?.key
        }).then(res => {

            if (res?.status === 200 || res?.status === 201) {
                setConfs(res?.data || res?.errors)
                setLoading(false)
            }
        })

    }, [token, activeLanguage?.key])

    return (
        <div className="section section--first">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="error">
                            <div className="error__content">
                                {
                                    loading ? <Loading/> : <>
                                        <h1 className="error__title">{confs?.title}</h1>
                                        <p className="error__text">
                                            {confs?.description}
                                        </p>
                                    </>
                                }


                                <FormButton
                                    isSmall={true}
                                    label={confs?.button ?? t('sidebar.home')}
                                    loading={false}
                                    disabled={false}
                                    onClick={e =>
                                        navigate(stringHelper.getLocalizedPath(currentLanguage, '/'))
                                }
                                />

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default EmailVerified
